export const USERS = 'https://natural-wines-api.onrender.com/users';
export const LOGOUT = 'https://natural-wines-api.onrender.com/users/logout';
export const LOGIN = 'https://natural-wines-api.onrender.com/sessions';
export const WINES = 'https://natural-wines-api.onrender.com/wines';
export const PRODUCERS = 'https://natural-wines-api.onrender.com/producers';
